export default [
  'rules-heading',
]
